module.exports = __webpack_public_path__ + "static/media/Sustainability.909e698d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Sustainability.svg
// module id = 249
// module chunks = 0